import { ChatStep } from './chat-flow-machine';

/**
 * Placeholder for free-text messages that don't match the current step's
 * expected input (button/field). Replace with a real LLM call once the
 * chat backend supports an onboarding `page_context` (see plan notes).
 */
export function freeTextFallback(step: ChatStep): string {
  return "Thanks for sharing that — I'll make a note of it. For now, let's finish up this question so I can find your plans faster.";
}
